import React,{useEffect, useState} from 'react'
import { Wrap } from './style';
import { Table,message } from 'antd'
import {AdminNewsApi} from "gmrfid-service-community-api-manager"

import { AnimationModal, Tables } from '@/components';
import moment from 'moment';

const index = (props) => {
    const id = props.location.search.split('?')[1]
    const [fields, setFields] = useState({id:id})
    const [limitTableTime, setLimitTableTime] = useState();
    const [data,setData] = useState([
        { id: 1, name: "评论数", number: 1 },
        { id: 2, name: "点赞数", number: 1 },
        { id: 3, name: "阅读人数", number: 1 },
        { id: 4, name: "分享次数", number: 1 },
    ])
    const columns = [
        {
            title: '序号',
            dataIndex: 'num',
            key: 'num',
        },
        {
            title: '评论内容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '账号',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: '时间',
            // dataIndex: 'time',
            key: 'time',
            render:text=><a style={{color:"black"}}>{moment(text.createDate).format("YYYY-MM-DD HH:mm:ss")}</a>
        },
        {
            title: '操作',
            key: 'address',
            width: 400,
            render: text => <a className="del" onClick={()=>{
                AdminNewsApi.deleteComment({form:{id:text.id}}).then(res=>{
                    setFields({...fields})
                    message.success("删除成功")
                })
            }}>删除</a>
        },
    ];
    
    useEffect(()=>{
        getNumber()
    },[])

    //获取相关统计数据
    const getNumber =()=>{
        AdminNewsApi.detail({form:{id:id}}).then(res=>{
            data[0].number = res.data.commentCount
            data[1].number = res.data.goodCount
            data[2].number = res.data.readCount
            data[3].number = res.data.sendCount
            setData([...data])
        })
    }

    const tablesTemplateOption = {
        columns,
        pagination: false,
        fields,
        parameterName: 'form',
        tableTime: limitTableTime,
        queryTableList: AdminNewsApi.commentList,
        tableTree: true,
        customSize: 10,
        newPagination: true,
    };
    return (
        <Wrap>
            <div className="title">查看数据</div>
            <div className="data">
                {data.map(item => {
                    return (
                        <div className="dataCard">
                            <div className="name">{item.name}</div>
                            <div className={`quantity ${item.id==1?"one":item.id==2?"two":item.id==3?"three":"four"}`}>{item.number}</div>
                        </div>
                    )
                })}
            </div>
            <Tables className="table" {...tablesTemplateOption} />
        </Wrap>
    )
}
export default index